/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
// import { EmailShareButton } from "react-share";

import { Grid } from 'react-bootstrap';
import { Empty, Button as AntdButton, Modal, Alert } from 'antd';
// import { ShareAltOutlined } from "@ant-design/icons";
import { ToastContainer } from 'react-toastify';

import MultipleCalc from 'components/multipleCalculator';
import LibraryTable from 'components/libraryTable';
import { LoadingScreen } from 'components/loadingScreen';

import { clearLibraryData } from 'redux/actions';

const Library = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const libraryData = useSelector((state) => state.dataReducers.libraryData);

  const [addNewModal, setAddNewModal] = useState(false);
  const [clearLibraryModal, setClearLibraryModal] = useState(false);

  // useEffect(() => {
  //   const { metaData, libraryData } = props;

  //   let newMetaData = [];

  //   // Meta data entered by user in either calculator or in the report page
  //   if (metaData) {
  //     Object.keys(metaData).forEach((key, index) => {
  //       let info = { key: `DATA${index + 1}`, value: metaData[key] };
  //       newMetaData.push(info);
  //     });
  //   }

  //   const removeEmptyLibraryInfo = libraryInfo.filter(
  //     (info) => info.length !== 0
  //   );

  //   if (metaData && libraryInfo.length !== 0) {
  //     setUpdatedLibraryInfo([...removeEmptyLibraryInfo, newMetaData]);
  //     // dispatch(setLibraryData(updatedLibraryInfo, libraryData));
  //   }
  // }, [metaData, libraryInfo]);

  // const saveToLocalStorage = () => {
  //   const myLibrary = localStorage.getItem("myLibrary");
  //   let storedLibraryData = myLibrary ? JSON.parse(myLibrary) : [];
  //   const librarySaveObj = {
  //     label: libaryName,
  //     value: {
  //       libraryData: libraryData,
  //       libraryInfo: libraryInfo
  //     }
  //   };
  //   storedLibraryData.push(librarySaveObj);
  //   localStorage.setItem("myLibrary", JSON.stringify(storedLibraryData));
  //   setSaveModal(false);
  //   setLibraryName("");
  //   toast.success(
  //     <div>
  //       <h3>Success</h3>{" "}
  //       <p>
  //         Successfully saved your library. You can access you saved libraries{" "}
  //         <Link to="/calculator">here</Link>.
  //       </p>
  //     </div>
  //   );
  // };

  // const myLibrary = localStorage.getItem("myLibrary");

  // const handleJsonDownload = () => {
  //   const jsonDownload = {
  //     libraryData: libraryData,
  //     libraryInfo: libraryInfo
  //   };
  //   const stringifyJson = JSON.stringify(jsonDownload);
  //   const blob = new Blob([stringifyJson], { type: "application/json" });
  //   saveAs(blob, `${jsonFileName}.json`);
  //   // localStorage.setItem("test", saveAs(blob, `${jsonFileName}.json`));
  //   setJsonExportModal(false);
  // };

  const addNewModalContainer = (
    <Modal
      title='Add new SPD(s) to library'
      visible={addNewModal}
      onCancel={() => setAddNewModal(false)}
      footer={[
        <AntdButton key='close' onClick={() => setAddNewModal(false)}>
          Close
        </AntdButton>,
      ]}
    >
      <MultipleCalc closeAddLibraryModal={setAddNewModal} />
    </Modal>
  );

  // const saveModalContainer = (
  //   <SharedModal
  //     isOpen={saveModal}
  //     onClose={() => setSaveModal(false)}
  //     title="Save library"
  //     body={
  //       <div>
  //         <ControlLabel>Name of your library</ControlLabel>
  //         <FormControl
  //           type="text"
  //           value={libaryName}
  //           onChange={event => setLibraryName(event.target.value)}
  //         />
  //       </div>
  //     }
  //     buttons={[
  //       { name: "Close", clickHandler: () => setSaveModal(false), bsStyle: "" },
  //       {
  //         name: "Save",
  //         clickHandler: saveToLocalStorage,
  //         bsStyle: "primary"
  //       }
  //     ]}
  //   />
  // );

  const clearLibraryModalContainer = (
    <Modal
      title='Clear library'
      visible={clearLibraryModal}
      onCancel={() => setClearLibraryModal(false)}
      footer={[
        <AntdButton key='close' onClick={() => setClearLibraryModal(false)}>
          Close
        </AntdButton>,
        <AntdButton
          key='delete'
          type='primary'
          onClick={() => {
            dispatch(clearLibraryData());
            setClearLibraryModal(false);
          }}
          danger
        >
          Delete
        </AntdButton>,
      ]}
    >
      Are you sure you want to clear the library?
    </Modal>
  );

  // const jsonExportModalContainer = (
  //   <SharedModal
  //     isOpen={jsonExportModal}
  //     onClose={() => setJsonExportModal(false)}
  //     title="Export to JSON"
  //     body={
  //       <div>
  //         <ControlLabel>Name of your file</ControlLabel>
  //         <FormControl
  //           type="text"
  //           value={jsonFileName}
  //           onChange={event => setJsonFileName(event.target.value)}
  //         />
  //       </div>
  //     }
  //     buttons={[
  //       {
  //         name: "Close",
  //         clickHandler: () => setJsonExportModal(false),
  //         bsStyle: ""
  //       },
  //       {
  //         name: "Save",
  //         clickHandler: handleJsonDownload,
  //         bsStyle: "primary"
  //       }
  //     ]}
  //   />
  // );

  // const emailShareButton = (
  //   <EmailShareButton
  //     url={`https://rcdemo.pnnl.gov/api/download/${fileIdToDownload}`}
  //     subject="TM-30 user library"
  //     body="Hi! Please find the link to my user library here."
  //   >
  //     <ShareAltOutlined css={styles.actionIcons} /> Share via email
  //   </EmailShareButton>
  // );

  const renderTableEmpty = () => (
    <Empty
      description={
        <span style={{ color: 'grey' }}>
          Use this button to add SPD&apos;s to your library
        </span>
      }
    >
      <AntdButton onClick={() => setAddNewModal(true)} type='primary'>
        Add New SPDs
      </AntdButton>
    </Empty>
  );

  return (
    <Grid css={styles.gridStyle(libraryData)}>
      {/* {libraryData.length !== 0 && (
        <SplitButton id="Actions Menu" bsStyle="info" title="Actions">
          <MenuItem onClick={() => setSaveModal(true)}>
            <SaveOutlined css={styles.actionIcons} />
            Save Library
          </MenuItem>
          <MenuItem onClick={() => setJsonExportModal(true)}>
            <DownloadOutlined css={styles.actionIcons} /> Save Library (JSON)
          </MenuItem>
          <MenuItem disabled={location.state !== "json"}>
            {location.state !== "json" ? (
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="right"
                overlay={
                  <Popover id="How to share?" title="How to share?">
                    Please upload a JSON file to be sharable!
                  </Popover>
                }
              >
                {emailShareButton}
              </OverlayTrigger>
            ) : (
              emailShareButton
            )}
          </MenuItem>
          <MenuItem onClick={() => setClearLibraryModal(true)}>
            <DeleteOutlined css={styles.actionIcons} />
            Clear Library
          </MenuItem>
        </SplitButton>
      )} */}

      {/* {saveModalContainer} */}
      {/* {jsonExportModalContainer} */}

      {addNewModalContainer}
      {clearLibraryModalContainer}
      <div css={styles.outerTableContainer}>
        <div css={styles.innerTableContainer}>
          <Alert
            css={styles.AlertStyle}
            message='User library data will be lost if you close
            the browser or refresh the page. Please make sure to save the
            library to a JSON for future use.'
            type='info'
            showIcon
            closable
          />

          {/* <p>
            <strong>Note:</strong> User library data will be lost if you close
            the browser or refresh the page. Please make sure to save the
            library to a JSON for future use.
          </p> */}
          <LibraryTable
            libraryData={libraryData}
            // libraryInfo={libraryInfo}
            libraryType='user'
            renderTableEmpty={renderTableEmpty}
          />
        </div>
      </div>
    </Grid>
  );
};

export default Library;

const styles = {
  gridStyle: (libraryData) => css`
    width: 95%;
    padding: 30px 0px;
  `,
  userLibraryNote: css`
    font-weight: 400;
    font-size: 16px;
  `,
  addNewButton: css`
    margin: 10px 10px 10px 0;
  `,
  actionIcons: css`
    font-size: 18px;
    margin-right: 5px;
  `,
  noDataText: css`
    position: absolute;
    top: 40%;
    left: 40%;
    opacity: 0.6;
  `,
  innerTableContainer: css`
    overflow-x: auto;
  `,
  outerTableContainer: css`
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 0 7px 2px #bbbbbb;
    padding: 0px 20px 20px 20px;
  `,
  AlertStyle: css`
    margin: 1rem 0;
  `,
};
